import { vfsContentNamespace } from '@/convex/vfs/content_namespace';

/** Selects a persisted location for UI discovery; the server still evaluates ACLs. */
export function threadWorkspacePanelRoot(args: {
  orgSlug: string;
  threadRootPath?: string | null;
  projectId?: string | null;
  projectRootPath?: string | null;
}): string | null {
  const path = args.projectId ? args.projectRootPath : args.threadRootPath;
  if (!path) return null;
  const namespace = vfsContentNamespace({
    workspaceStorageSlug: args.orgSlug,
    path,
    kind: 'directory',
  });
  return namespace === 'home' || namespace === 'drive' ? path : null;
}
